<template>
  <a-drawer
    width="80%"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-card :bordered="false">
      <!-- 条件搜索 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="48">
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="版本号名称">
                <a-input
                  v-model="queryParam.versionName"
                  placeholder="请输入"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <a-form-item label="版本号">
                <a-input
                  v-model="queryParam.versionCode"
                  placeholder="请输入"
                  allow-clear
                />
              </a-form-item>
            </a-col>
            <a-col
              :md="6"
              :sm="24"
            >
              <span class="table-page-search-submitButtons">
                <a-button
                  type="primary"
                  @click="handleQuery"
                ><a-icon type="search" />查询</a-button>
                <a-button
                  style="margin-left: 8px"
                  @click="resetQuery"
                ><a-icon type="redo" />重置</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- 操作 -->
      <div class="table-operations">
        <a-button
          type="primary"
          @click="$refs.bindForm.handleAdd(queryParam.customerId)"
        >
          <a-icon type="plus" />新增
        </a-button>
        <table-setting
          :style="{ float: 'right' }"
          :table-size.sync="tableSize"
          v-model="columns"
          :refresh-loading="loading"
          @refresh="getList"
        />
      </div>
      <!-- 增加修改 -->
      <bindForm
        ref="bindForm"
        @ok="getList"
      />
      <!-- 数据展示 -->
      <a-table
        :loading="loading"
        :size="tableSize"
        rowKey="id"
        :columns="columns"
        :data-source="list"
        :pagination="false"
        :bordered="tableBordered"
      >
        <!-- <span
          slot="appType"
          slot-scope="text, record"
        >
          <span>固件</span>
        </span> -->
        <span
          slot="upNotes"
          slot-scope="text, record"
        >
          <a-popover title="更新说明">
            <template slot="content">{{ record.upNotes }}</template>
            <a type="primary">查看</a>
          </a-popover>
        </span>

        <span
          slot="isShow"
          slot-scope="text, record"
        >
          {{ record.isShow === 0 ? '无效' : '有效' }}
        </span>

        <span
          slot="downloadUrl"
          slot-scope="text, record"
        >
          <a-popover title="下载地址">
            <template slot="content">{{ record.downloadUrl }}</template>
            <a type="primary">查看</a>
          </a-popover>
        </span>
        <span
          slot="createTime"
          slot-scope="text, record"
        >
          {{ parseTime(record.createTime) }}
        </span>
        <span
          slot="operation"
          slot-scope="text, record"
        >
          <a @click="handleiSshow(record)">
            {{ record.isShow === 0 ? '使有效' : '使无效' }}
          </a>

          <a-divider type="vertical" />
          <a @click="handleDelete(record)"> 删除 </a>
        </span>
      </a-table>
      <!-- 分页 -->
      <a-pagination
        class="ant-table-pagination"
        show-size-changer
        show-quick-jumper
        :current="queryParam.pageNum"
        :total="total"
        :page-size="queryParam.pageSize"
        :showTotal="(total) => `共 ${total} 条`"
        @showSizeChange="onShowSizeChange"
        @change="changeSize"
      />
    </a-card>
  </a-drawer>
</template>

<script>
import { pageappVersion, delappVersion, update } from '@/api/system/version'
import { unbindtoa } from '@/api/tram/customer'
import bindForm from './bindForm.vue'
import { tableMixin } from '@/store/table-mixin'
export default {
  name: 'BindForm',
  props: {},
  mixins: [tableMixin],
  components: {
    bindForm
  },
  data () {
    return {
      submitLoading: false,
      formTitle: '',
      queryParam: {
        appType: 3,
        customerId: undefined,
        versionName: undefined,
        versionCode: undefined,
        pageNum: 1,
        pageSize: 10
      },
      list: [],
      loading: false,
      total: 0,
      open: false,
      ids: [],
      columns: [
        {
          title: '文件名称',
          dataIndex: 'remark',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '固件版本号',
          dataIndex: 'versionName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '更新说明',
          dataIndex: 'upNotes',
          scopedSlots: { customRender: 'upNotes' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '下载地址',
          dataIndex: 'downloadUrl',
          scopedSlots: { customRender: 'downloadUrl' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'isShow',
          scopedSlots: { customRender: 'isShow' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '添加时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          align: 'center',
          width: 160
        },
        {
          title: '操作',
          dataIndex: 'operation',
          width: 160,
          scopedSlots: { customRender: 'operation' },
          align: 'center'
        }
      ]
    }
  },
  filters: {},
  created () { },
  computed: {},
  watch: {},
  mounted () { },
  methods: {
    onClose () {
      this.open = false
    },
    // 取消按钮
    cancel () {
      this.open = false
    },
    /** 搜索按钮操作 */
    handleQuery () {
      this.queryParam.pageNum = 1
      this.getList()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParam = {
        sortField: 'createTime',
        sortOrder: 'DESCEND',
        appType: undefined,
        versionName: null,
        versionCode: null,
        pageNum: 1,
        pageSize: 10
      }
      this.handleQuery()
    },
    /** 修改按钮操作 */
    handleUpdate (row) {
      this.open = true
      this.queryParam.customerId = row.id
      this.getList()
    },
    getList () {
      this.loading = true
      pageappVersion(this.queryParam).then((response) => {
        this.list = response.data.records
        this.total = response.data.total
        this.loading = false
      })
    },
    onShowSizeChange (current, pageSize) {
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    changeSize (current, pageSize) {
      this.queryParam.pageNum = current
      this.queryParam.pageSize = pageSize
      this.getList()
    },
    onSelectChange (selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
      this.ids = this.selectedRows.map((item) => item.id)
      this.single = selectedRowKeys.length !== 1
      this.multiple = !selectedRowKeys.length
    },
    handleiSshow (row) {
      var that = this
      update({ customerId: this.queryParam.customerId, versionId: row.id, isShow: row.isShow === 0 ? 1 : 0 }).then(
        (res) => {
          that.getList()
        }
      )
    },
    /** 删除按钮操作 */
    handleDelete (row) {
      var that = this
      console.log(row)
      this.$confirm({
        title: '确认删除所选中数据?',
        content: '当前选中名称为' + row.remark + '的数据',
        onOk () {
          unbindtoa({ customerId: that.queryParam.customerId, versionIds: [row.id] }).then(() => {
            that.getList()
            that.$message.success('删除成功', 3)
          })
        },
        onCancel () { }
      })
    }
  }
}
</script>
